import { useState, useEffect, React, useReducer } from 'react'
import { initialstate, myreducer, fetchbygetmethod,fetchbyputmethod, fetchbypostmethod } from '../Commonfiles/Myreducer';
import Spinner from '../Commonfiles/spinner';
import Nodatafound from '../Commonfiles/nodatafound';
import axios from 'axios';
import { Gotohome } from '../Commonfiles/checkfortoken';
//import { log } from 'console';
function Dsbankdetail() { 
	const imagedefault = "/assets/images/users/avatar-1.jpg";
	
	var [mydata, setmydata] = useReducer(myreducer, initialstate);
	var [updatemydata, setupdatemydata] = useReducer(myreducer, initialstate);
	const [myimgupload, setmyimgupload] = useReducer(myreducer, initialstate);
	  const [getstate, setgetstate] = useState(null);

	//photo section

	const [filecheque, setfilecheque] = useState(null);
	const [filechequeimage, setfilechequeimage] = useState(null);
	

	var [selectbankdetail, setselectbankdetail] = useReducer(myreducer, initialstate);

    const handleFileChangeforcheque = (event) => {
		const imgfile = event.target.files[0];
		
		if (imgfile) {


			const reader = new FileReader();
			reader.onloadend = () => {

				setfilechequeimage(reader.result);
				setfilecheque(imgfile);

			};
			reader.readAsDataURL(imgfile);

		}
	};

	const onSubmitcheque = async (e) => {

		e.preventDefault();

		if (!filecheque) {

			console.error('No file selected.');
			return;
		}
	const imagename=sessionStorage.getItem('tempID')+'_cheque';
	// Create a new file with the new name
    // const newFileName = `${imagename}.${filecheque.name.split('.').pop()}`; // e.g., dsid.jpg
    // const newFile = new File([filecheque], newFileName, { type: filecheque.type });

	 // Always save as .jpeg, regardless of the original format
	 const newFileName = `${imagename}.jpeg`;

	 // Convert file type to JPEG explicitly
	 const newFile = new File([filecheque], newFileName, { type: "image/jpeg" });

	const formData = new FormData();
  
	formData.append('file', newFile);

		
		try {
			const res = await axios.post(process.env.REACT_APP_URL + 'upload', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			});

			const { fileName } = res.data;

			console.log('fileName', fileName);

			fetchbypostmethod(setmyimgupload, 'dsuploadcheque', { fileName: fileName, applicantid: sessionStorage.getItem('applicantID') });

			alert("Image Uploaded!!");
		} catch (err) {
			console.error('ret', err);
		}
	};






	const [filepan, setfilepan] = useState(null);
	const [filepanimage, setfilepanimage] = useState(null);
    const handleFileChangeforpan = (event) => {
		const imgfile = event.target.files[0];
		
		if (imgfile) {


			const reader = new FileReader();
			reader.onloadend = () => {

				setfilepanimage(reader.result);
				setfilepan(imgfile);

			};
			reader.readAsDataURL(imgfile);

		}
	};

	const onSubmitpan = async (e) => {
		
		e.preventDefault();

		if (!filepan) {
          
			console.error('No file selected.');
			return;
		}
		const imagename=sessionStorage.getItem('tempID')+'_pan';
		// Create a new file with the new name
		// const newFileName = `${imagename}.${filepan.name.split('.').pop()}`; // e.g., dsid.jpg
		// const newFile = new File([filepan], newFileName, { type: filepan.type });

		 // Always save as .jpeg, regardless of the original format
		 const newFileName = `${imagename}.jpeg`;

		 // Convert file type to JPEG explicitly
		 const newFile = new File([filepan], newFileName, { type: "image/jpeg" });
	
		const formData = new FormData();
	  
		formData.append('file', newFile);
	
		try {
			const res = await axios.post(process.env.REACT_APP_URL + 'upload', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			});

			const { fileName } = res.data;

			console.log('fileName', fileName);

			fetchbypostmethod(setmyimgupload, 'dsuploadpan', { fileName: fileName, applicantid: sessionStorage.getItem('applicantID') });
			alert("Image Uploaded!!");
			
		} catch (err) {
			alert("err"+err);
			console.error('ret', err);
		}
	};








	
	const [fileselfie, setfileselfie] = useState(null);
	const [fileSelfieimg, setfileSelfieimg] = useState(null);
    const handleFileChangeforselfie = (event) => {
		const imgfile = event.target.files[0];
		
		if (imgfile) {


			const reader = new FileReader();
			reader.onloadend = () => {

				setfileSelfieimg(reader.result);
				setfileselfie(imgfile);

			};
			reader.readAsDataURL(imgfile);

		}
	};

	const onSubmitselfie = async (e) => {
		
		e.preventDefault();

		if (!fileselfie) {
          
			console.error('No file selected.');
			return;
		}
		const imagename=sessionStorage.getItem('tempID')+'_selfie';
		// Create a new file with the new name
		// const newFileName = `${imagename}.${fileselfie.name.split('.').pop()}`; // e.g., dsid.jpg
		// const newFile = new File([fileselfie], newFileName, { type: fileselfie.type });


		 // Always save as .jpeg, regardless of the original format
		 const newFileName = `${imagename}.jpeg`;

		 // Convert file type to JPEG explicitly
		 const newFile = new File([fileselfie], newFileName, { type: "image/jpeg" });
	
		const formData = new FormData();
	  
		formData.append('file', newFile);
	
		try {
			const res = await axios.post(process.env.REACT_APP_URL + 'upload', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			});

			const { fileName } = res.data;

			console.log('fileName', fileName);

			fetchbypostmethod(setmyimgupload, 'dsuploadselfie', { fileName: fileName, applicantid: sessionStorage.getItem('applicantID') });
			alert("Image Uploaded!!");
			
		} catch (err) { 
			alert("err"+err);
			console.error('ret', err);
		}
	};


	const [filesignature, setfilesignature] = useState(null);
	const [filesignatureimg, setfilesignatureimg] = useState(null);
    const handleFileChangeforsignature = (event) => {
		const imgfile = event.target.files[0];
		
		if (imgfile) {


			const reader = new FileReader();
			reader.onloadend = () => {

				setfilesignatureimg(reader.result);
				setfilesignature(imgfile);

			};
			reader.readAsDataURL(imgfile);

		}
	};

	const onSubmitsignature = async (e) => {
		
		e.preventDefault();

		if (!filesignature) {
          
			console.error('No file selected.');
			return;
		}
		const imagename=sessionStorage.getItem('tempID')+'_signature';
		// Create a new file with the new name
		// const newFileName = `${imagename}.${filesignature.name.split('.').pop()}`; // e.g., dsid.jpg
		// const newFile = new File([filesignature], newFileName, { type: filesignature.type });

		 // Always save as .jpeg, regardless of the original format
		 const newFileName = `${imagename}.jpeg`;

		 // Convert file type to JPEG explicitly
		 const newFile = new File([filesignature], newFileName, { type: "image/jpeg" });
	
		const formData = new FormData();
	  
		formData.append('file', newFile);
	
		try {
			const res = await axios.post(process.env.REACT_APP_URL + 'upload', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			});

			const { fileName } = res.data;

			console.log('fileName', fileName);

			fetchbypostmethod(setmyimgupload, 'dsuploadsignature', { fileName: fileName, applicantid: sessionStorage.getItem('applicantID') });
			alert("Image Uploaded!!");
			
		} catch (err) {
			alert("err"+err);
			console.error('ret', err);
		}
	};


	const [fileaadharfront, setfileaadharfront] = useState(null);
	const [fileaadharfrontimg, setfileaadharfrontimg] = useState(null);
    const handleFileChangeforaadharfront = (event) => {
		const imgfile = event.target.files[0];
		
		if (imgfile) {


			const reader = new FileReader();
			reader.onloadend = () => {

				setfileaadharfrontimg(reader.result);
				setfileaadharfront(imgfile);

			};
			reader.readAsDataURL(imgfile);

		}
	};

	const onSubmitaadharfront = async (e) => {
		
		e.preventDefault();

		if (!fileaadharfront) {
          
			console.error('No file selected.');
			return;
		}
		const imagename=sessionStorage.getItem('tempID')+'_aadharfront';
		// Create a new file with the new name
		// const newFileName = `${imagename}.${fileaadharfront.name.split('.').pop()}`; // e.g., dsid.jpg
		// const newFile = new File([fileaadharfront], newFileName, { type: fileaadharfront.type });
	

		 // Always save as .jpeg, regardless of the original format
		 const newFileName = `${imagename}.jpeg`;

		 // Convert file type to JPEG explicitly
		 const newFile = new File([fileaadharfront], newFileName, { type: "image/jpeg" });


		const formData = new FormData();
	  
		formData.append('file', newFile);
	
		try {
			const res = await axios.post(process.env.REACT_APP_URL + 'upload', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			});

			const { fileName } = res.data;

			console.log('fileName', fileName);

			fetchbypostmethod(setmyimgupload, 'dsuploadaadharfront', { fileName: fileName, applicantid: sessionStorage.getItem('applicantID') });
			alert("Image Uploaded!!");
			
		} catch (err) {
			alert("err"+err);
			console.error('ret', err);
		}
	};


	const [fileaadharback, setfileaadharback] = useState(null);
	const [fileaadharbackimg, setfileaadharbackimg] = useState(null);
    const handleFileChangeforaadharback = (event) => {
		const imgfile = event.target.files[0];
		
		if (imgfile) {


			const reader = new FileReader();
			reader.onloadend = () => {

				setfileaadharbackimg(reader.result);
				setfileaadharback(imgfile);

			};
			reader.readAsDataURL(imgfile);

		}
	};

	const onSubmitaadharback = async (e) => {
		
		e.preventDefault();

		if (!fileaadharback) {
          
			console.error('No file selected.');
			return;
		}
		const imagename=sessionStorage.getItem('tempID')+'_aadharback';
		// Create a new file with the new name
		// const newFileName = `${imagename}.${fileaadharback.name.split('.').pop()}`; // e.g., dsid.jpg
		// const newFile = new File([fileaadharback], newFileName, { type: fileaadharback.type });
	

		 // Always save as .jpeg, regardless of the original format
		 const newFileName = `${imagename}.jpeg`;

		 // Convert file type to JPEG explicitly
		 const newFile = new File([fileaadharback], newFileName, { type: "image/jpeg" });


		const formData = new FormData();
	  
		formData.append('file', newFile);
	
		try {
			const res = await axios.post(process.env.REACT_APP_URL + 'upload', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			});

			const { fileName } = res.data;

			console.log('fileName', fileName);

			fetchbypostmethod(setmyimgupload, 'dsuploadaadharback', { fileName: fileName, applicantid: sessionStorage.getItem('applicantID') });
			alert("Image Uploaded!!");
			
		} catch (err) {
			alert("err"+err);
			console.error('ret', err);
		}
	};



	async function Getstatesname() {
		await fetch(process.env.REACT_APP_URL + "getstatesname", {
		  method: "GET",
		  headers: {
			"Content-Type": "application/json",
		  }
		})
		  .then((response) => response.json())
		  .then((data) => {
			setgetstate(data.recordset);
		  })
		  .catch((err) => {
			console.log("error", err);
		  });
	  }











	function getdata() {
		fetchbygetmethod(setmydata, 'bankdetails', { tempid:sessionStorage.getItem("tempID") })
		
	}

	function getbankdetail() {
		fetchbygetmethod(setselectbankdetail, 'bankdetailselect', {})
		console.log(selectbankdetail);
		
	}
 
	function updatedata() { 

		var bankname=document.getElementById('selectbankid').value;
		var branchname=document.getElementById('txtbranchname').value;
		var bankacc=document.getElementById('txtaccno').value;
		var bankpanno=document.getElementById('txtpanno').value;
		var bankstate=document.getElementById('selectstates').value;
		var bankifsccode=document.getElementById('txtifsccode').value;

		fetchbyputmethod(setupdatemydata, 'updatebankdetails', {
			tempid: sessionStorage.getItem("tempID"),
			bankid: bankname,
			accno: bankacc,
			ifscno: bankifsccode,
			panno: bankpanno,
			branchname: branchname,
			stateid: bankstate
		})

		alert("Successfully updated bank details!");
		// .catch(error => {
		// 	console.error("Error updating data:", error);
		// 	alert("An error occurred. Please try again.");
		// });
		
		
	}


	useEffect(() => { getbankdetail() ; Getstatesname(); }, []) 

	useEffect(() => { getdata(sessionStorage.getItem('tempID')); }, []);
	useEffect(() => {
		// if (isFirstRender.current) {
		// 	isFirstRender.current = false;
		//   } else {
		//console.log("mydata",myimgupload);
		if (myimgupload.myerror == true)
			alert("Please Upload Your Image Again!!");
		else if (myimgupload.initialstage==false && myimgupload.myloading == false)
		{
			alert('File uploaded Successfully');
			getdata(sessionStorage.getItem('tempID'));
			
		}
			
		// }
	
	}, [myimgupload])



	return (
		<div class="content-page">
			<div class="content">
				<div class="">
					<div class="page-header-title">
						<h4 class="page-title">User Profile</h4>

					</div>
				</div>

				<div class="page-content-wrapper ">
					<div class="container">
						<div class="row">
							<div class="col-sm-12">
								<div class="panel panel-primary">
									<div class="panel-body">
										<h4 class="m-t-0 m-b-30">Bank Details</h4>
										<hr width="100%" />
										{mydata.initialstage==true?<></>:
										  mydata.myloading ?<Spinner/>
										  :mydata.myerror ?<Nodatafound/>
										  :
										    
											
												
													<div class="row">
														<div class="col-sm-6 col-xs-12">
 
						 									<div class="m-t-20">
																<form class="" action="#">
																<div className="form-group">
    <label>Bank Name</label>
    {mydata.mypost.length > 0 && mydata.mypost[0].bankname ? (
        <input
            type="text"
            className="form-control"
            readOnly
            defaultValue={mydata.mypost[0].bankname}
        />
    ) : (
        <select className="form-control" id='selectbankid'>
            <option value="">Select Bank</option>
            {Array.isArray(selectbankdetail.mypost) && selectbankdetail.mypost.length > 0 ? (
        selectbankdetail.mypost.map((bank, index) => (
            <option  value={bank.BankId}>
                {bank.BankName}
                    </option>
                )) 
            ) : (
                <option disabled>Loading banks...</option>
            )}
        </select>
    )}
</div>

      

																	<div class="form-group">
																		<label>Branch Name</label>
																		

																		<input type='text'
																				class="form-control" id='txtbranchname'
																				readOnly={mydata.mypost.length > 0 && mydata.mypost[0].branchname!=null?true:false}
																				defaultValue={mydata.mypost.length > 0 ?mydata.mypost[0].branchname:''}
																			/>



																	</div>
																	
																	<div class="form-group">
																		<label>Account No.</label>
																		

																			<input type='text'
																				class="form-control" id='txtaccno'
																				readOnly={mydata.mypost.length > 0 && mydata.mypost[0].accno!=null?true:false}
																				defaultValue={mydata.mypost.length > 0 ?mydata.mypost[0].accno:''}
																			/>
																	</div>

																	<div class="form-group">
																		<label>PanNo</label>
																		

																			<input type='text'
																				class="form-control" id='txtpanno'
																				readOnly={mydata.mypost.length > 0 && mydata.mypost[0].panno!=null?true:false}
																				defaultValue={mydata.mypost.length > 0 ?mydata.mypost[0].panno:''}
																			/>
																	</div>

																	<div class="form-group">
																		<label>Cheque Label Image</label>

																		<div>
																			<input type="file" class="form-control" required  onChange={handleFileChangeforcheque}
																			/>
																		</div>
																		<div style={{marginTop:10,marginLeft:67}}>
																		<img style={{ height: 188, width: 240 }} 
																		src={filechequeimage ? filechequeimage : Array.isArray(mydata.mypost) && mydata.mypost.length > 0 && mydata.mypost[0].chequephoto ? './uploads/' + mydata.mypost[0].chequephoto : process.env.PUBLIC_URL + imagedefault} alt=""
														className="img-circle" />

																		</div>
																	</div>

																	<div class="form-group">
																		<div>
																			<button type="submit" onClick={(e)=>onSubmitcheque(e)}
																				class="btn btn-primary waves-effect waves-light">
									 											Submit Cheque</button>
																			
																			
																		</div>
																	</div>



																	<div class="form-group">
																		<label>Selfie Image</label>

																		<div>
																			<input type="file" class="form-control" required  onChange={handleFileChangeforselfie}
																			/>
																		</div>
																		<div  style={{marginTop:10,marginLeft:67}}>
																		<img style={{ height: 188, width: 240 }} 
																		src={fileSelfieimg ? fileSelfieimg : Array.isArray(mydata.mypost) && mydata.mypost.length > 0 && mydata.mypost[0].Selfie ? './uploads/' + mydata.mypost[0].Selfie : process.env.PUBLIC_URL + imagedefault} alt=""
														className="img-circle" />

																		</div>
																	</div>

																	<div class="form-group">
																		<div>
																			<button type="submit" onClick={(e)=>onSubmitselfie(e)}
																				class="btn btn-primary waves-effect waves-light">
									 											Submit Selfie </button>
																			
																			
																		</div>
																	</div>


																	<div class="form-group" style={{marginTop:16}}>
																		<label>Adhar Front Image</label>
																		<div>
																			<input type="file" class="form-control" onChange={handleFileChangeforaadharfront} required />
																		</div>
																		<div style={{marginTop:10,marginLeft:67}}>
																		<img style={{ height: 188, width: 240 }} src={fileaadharfrontimg?fileaadharfrontimg:Array.isArray(mydata.mypost) && mydata.mypost.length > 0 && mydata.mypost[0].AdhaarFront ? './uploads/' + mydata.mypost[0].AdhaarFront : process.env.PUBLIC_URL + imagedefault} alt="" 
														className="img-circle" />

																		</div>

																	</div>

																	<div class="form-group">
																		<div>
																			
																			<button type="reset" onClick={(e)=>onSubmitaadharfront(e)} 
																				class="btn btn-primary waves-effect m-l-5">
																				Submit Adhar Front</button>
																		</div>
																	</div>





																</form>
															</div>
														</div>
														<div class="col-sm-6 col-xs-12">

															<div class="m-t-20">
																<form action="#">
																	<div class="form-group">
																		<label>Bank Branch State</label>
																		{mydata.mypost.length > 0 && mydata.mypost[0].bankname ? (
      

																			<input type='text'
																				class="form-control"
																				readOnly={mydata.mypost.length > 0 && mydata.mypost[0].statename!=null?true:false}
																				defaultValue={mydata.mypost.length > 0 ?mydata.mypost[0].statename:''}
																			/>) :(

<select className="form-control" required
            id='selectstates'
           
          >
            <option value="">Select State</option>
            {getstate && getstate.map((state, index) => (
              <option key={index} value={state.StateId}>
                {state.StateName}
              </option>
            ))}
          </select> )}
																	</div>
																	<div class="form-group">
																		<label>IFSC Code</label>
																

																			<input type='text'
																				class="form-control" id='txtifsccode'
																				readOnly={mydata.mypost.length > 0 && mydata.mypost[0].ifscno!=null?true:false}
																				defaultValue={mydata.mypost.length > 0 ?mydata.mypost[0].ifscno:''}
																			/>
																		<div class="form-group">
																			<div >
																				<button type="submit" style={{marginTop:-61,marginLeft:300}}
																					class="btn btn-primary waves-effect waves-light">
																					Bank Branch Details</button>

																			</div>
																		</div>

																	</div>

																	
																	
																	<div class="form-group" style={{marginTop:-20}}>
																		<label>Cheque No.</label>
																		

																			<input type='text'
																				class="form-control" id='txtchequeno'
																				readOnly={mydata.mypost.length > 0 && mydata.mypost[0].chequeno!=null?true:false}
																				defaultValue={mydata.mypost.length > 0 ?mydata.mypost[0].chequeno:''}
																			/>
																	</div>
																	<div class="form-group" style={{marginTop:92}}>
																		<label>Pan Card Image</label>
																		<div>
																			<input type="file" class="form-control" onChange={handleFileChangeforpan} required />
																		</div>
																		<div style={{marginTop:10,marginLeft:67}}>
																		<img style={{ height: 188, width: 240 }} src={filepanimage?filepanimage:Array.isArray(mydata.mypost) && mydata.mypost.length > 0 && mydata.mypost[0].panphoto ? './uploads/' + mydata.mypost[0].panphoto : process.env.PUBLIC_URL + imagedefault} alt="" 
														className="img-circle" />

																		</div>

																	</div>

																	<div class="form-group">
																		<div>
																			
																			<button type="reset" onClick={(e)=>onSubmitpan(e)}
																				class="btn btn-primary waves-effect m-l-5">
																				Submit PAN</button>
																		</div>
																	</div>

																	<div class="form-group" style={{marginTop:16}}>
																		<label>Signature Image</label>
																		<div>
																			<input type="file" class="form-control" onChange={handleFileChangeforsignature} required />
																		</div>
																		<div style={{marginTop:10,marginLeft:67}}>
																		<img style={{ height: 188, width: 240 }} src={filesignatureimg?filesignatureimg:Array.isArray(mydata.mypost) && mydata.mypost.length > 0 && mydata.mypost[0].signature ? './uploads/' + mydata.mypost[0].signature : process.env.PUBLIC_URL + imagedefault} alt="" 
														className="img-circle" />

																		</div>

																	</div>

																	<div class="form-group">
																		<div>
																			
																			<button type="reset" onClick={(e)=>onSubmitsignature(e)} 
																				class="btn btn-primary waves-effect m-l-5">
																				Submit Signature </button>
																		</div>
																	</div>



																	<div class="form-group" style={{marginTop:16}}>
																		<label>Adhar Back Image</label>
																		<div>
																			<input type="file" class="form-control" onChange={handleFileChangeforaadharback} required />
																		</div>
																		<div style={{marginTop:10,marginLeft:67}}>
																		<img style={{ height: 188, width: 240 }} src={fileaadharbackimg?fileaadharbackimg:Array.isArray(mydata.mypost) && mydata.mypost.length > 0 && mydata.mypost[0].AdhaarBack ? './uploads/' + mydata.mypost[0].AdhaarBack : process.env.PUBLIC_URL + imagedefault} alt="" 
														className="img-circle" />

																		</div>

																	</div>

																	<div class="form-group">
																		<div>
																			
																			<button type="reset" onClick={(e)=>onSubmitaadharback(e)} 
																				class="btn btn-primary waves-effect m-l-5">
																				Submit Adhar Back</button>
																		</div>
																	</div>
																</form>

																




															</div>

														</div>

														<hr width="100%" />

                                                        <div class="form-group">
																		<div>
																			
																			<button type="reset" style={{marginLeft:690}} onClick={updatedata}
																				class="btn btn-primary waves-effect m-l-5">
																				Submit </button>
																		</div>
																	</div>

													</div>
												
											
										}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* <Gotohome mydata={mydata} /> */}
		</div>
	)
}

export default Dsbankdetail;